import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useDeleteAccommodation = createTripMutation<
    void,
    { tripId: string; accommodationId: number }
>({
    mutationFn: async ({ tripId, accommodationId }) => {
        await api.delete(`/trips/${tripId}/accommodations/${accommodationId}`)
    },
    invalidate: ({ tripId }) => [queryKeys.accommodations(tripId)],
})
